export function NotFoundScreen() {
  return <div>404 page</div>
}
